// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Mcl_","title":"Info_title__hn21S","links":"Info_links__36_tg","link":"Info_link__3BvEW","logo":"Info_logo__JGbv1"};